import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';

import arrow from '~/styles/img/product-testimonial-arrow.svg';

export const StyledIngredients = styled.div`
  padding: 0px 20px;
  padding-bottom: 20px;
  margin-bottom: ${pxtorem(80)};

  h3 {
    text-align: center;
    font-size: ${pxtorem(40)};
    font-weight: 300;
    line-height: 1;

    @media (min-width: 768px) {
      font-size: ${pxtorem(60)};
    }
  }

  .swiper-wrapper {
    min-height: calc(360px + 48px);
  }

  .ingredients-prev,
  .ingredients-next {
    display: none;
  }

  .swiper-pagination-bullet {
    background-color: var(--black);
    opacity: 0.1;
    transition: opacity 0.3s var(--cubic-ease);
    
    &-active, &:active, &:hover  {
      opacity: 1;
    }
  }

  @media (max-width: 1128px) {
    .swiper {
        // break out to fill full width
        margin-left: -20px;
        margin-right: -20px;
        padding-left: 11px;
        padding-right: 11px;
      }
    }
  }

  @media (min-width: 1128px) {
    // three slides at 360px width + 16px margins
    .swiper {
      max-width: 1128px;
      margin: 0 auto;
    }
  }

  @media (min-width: 1288px) {
    // three slides + space for arrows
    .swiper {
      margin: 0;
    }

    .swiper-pagination {
      display: none;
    }

    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;
    }

    .ingredients-prev,
    .ingredients-next {
      display: block;
      flex: 0 0 40px;
      height: 40px;
      mask: url(${arrow}) center no-repeat;
      mask-size: contain;
      background: var(--black);
      transition: background 250ms, opacity 250ms, visibility 0ms;
      cursor: pointer;
      position: relative;
      transform: translateY(-50%);

      ${desktopHover(`background: var(--coral);`)}
    }

    .ingredients-prev {
      transform: translateY(-50%) scale(-1, 1);
    }
  }

  .swiper-slide {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 270px;
    height: 330px;
    background: var(--gray);
    border-radius: 10px;

    & figure {
      margin: 0 20px;
      text-align: center;
      img {
        margin: 0 auto;
      }
    }

    & .name {
      position: absolute;
      inset: auto 20px 20px;
      font-size: ${pxtorem(16)};
      font-weight: 400;
      text-align: center;
    }

    @media (min-width: 768px) {
      width: 360px;
      height: 360px;

      & .name {
        font-weight: 500;
      }
    }
  }
`;
